import React from 'react'

interface FileUploadContextType {
  openSystemUserFilesFileSelector: () => void
  openSystemWritingSampleFileSelector: () => void
  cancelUserFileUpload: (clientTmpId: string) => void
  userFilesUploadDisabled: boolean
  userFilesUploadDisabledReason?: string
}

export const FileUploadContext = React.createContext<FileUploadContextType>({
  openSystemUserFilesFileSelector: () => {
    // default, in case openSystemUserFilesFileSelector has not yet been defined
    console.warn('openSystemUserFilesFileSelector has not been defined')
  },
  openSystemWritingSampleFileSelector: () => {
    // default, in case openSystemWritingSampleFileSelector has not yet been defined
    console.warn('openSystemWritingSampleFileSelector has not been defined')
  },
  cancelUserFileUpload: () => {
    // default, in case cancelUserFileUpload has not yet been defined
    console.warn('cancelUserFileUpload has not been defined')
  },
  userFilesUploadDisabled: true,
  userFilesUploadDisabledReason: 'Matter Files upload is unavailable.',
})
